
<template>
  <div :id="id" class="container-fluid" style="position: relative; height: 100%; text-align: center;">
    <div v-show="showDragAndDrop" id="drop-zone" :class="{ imageHovering: imageDragging }">
      <div v-if="fileNames.length > 0 || file.FileName !== ''" class="images-uploaded-text">
        <p>Uploaded:</p>
        <p 
          v-for="(image, index) in fileNames.slice(0,7)" 
          :key="image + index"
          class="file-names"
        >
          {{ image }}
        </p>
        <p v-if="fileNames.length > 7 ">
          ...
        </p>
        <div v-if="allowMultiple === false">
          {{ file.FileName | ellipseShorten(24) }}
        </div>
      </div>
      <span class="image-upload-text">{{ dropZoneLabel }}</span>
      <input 
        id="fileUploadInput"
        ref="fileUploadInput" 
        type="file" 
        name="file"
        :accept="acceptedFileTypes" 
        :multiple="allowMultiple" 
        @change="OnFileChange()"  
        @dragenter="imageDragging=true" 
        @dragend="imageDragging=false" 
        @dragleave="imageDragging=false"
      >
      <ToolTipPopOver
        v-if="showTooltip === true"
        :popover-message="tooltipText"
        :popover-title="tooltipTitle"
      />
    </div>
    <div v-if="showDescription && description !== ''" class="description">
      {{ description }}
    </div>
    <DnFunctionButton
      button-id="fileUploadBrowseButton"
      :callback-fn="OpenFileExplorer"
      :text="uploadButtonLabel"
      :size="largeSize"
    />
    <DnFunctionButton
      v-if="showSubmitButton"
      button-id="fileUploadSubmitButton"
      :callback-fn="OnSubmit"
      text="Submit"
      :size="largeSize"
      :loading="draftLoading"
    />
    <div v-if="!showDragAndDrop">
      <ToolTipPopOver
        v-if="showTooltip === true"
        :popover-message="tooltipText"
        :popover-title="tooltipTitle"
      />
      <div v-if="fileNames.length > 0 || file.FileName !== ''" class="ie-images-uploaded-text">
        <p>Uploaded:</p>
        <p 
          v-for="(image, index) in fileNames.slice(0,7)" 
          :key="image + index"
          class="file-names"
        >
          {{ image }}
        </p>
        <p v-if="fileNames.length > 7 ">
          ...
        </p>
        <div v-if="allowMultiple === false">
          {{ file.FileName | ellipseShorten(24) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $                from "jquery"
  import { sizeHelper }   from "@/components/mixins/sizeHelper"
  import { mapGetters }   from "vuex"
  import DnFunctionButton from "@/components/Elements/DnFunctionButton"
  import ToolTipPopOver   from "@/components/Elements/ToolTipPopover"
  import { constants }    from "@/const"

  export default {
    components: {
      DnFunctionButton,
      ToolTipPopOver
    },
    mixins: [sizeHelper],
    props: {
      dropZoneLabel: {
        type: String,
        default: ""
      },
      uploadButtonLabel: {
        type: String,
        default: ""
      },
      allowMultiple: {
        type: Boolean,
        default: false
      },
      showDragAndDrop: {
        type: Boolean,
        default: true
      },
      acceptedFileTypes: {
        type: String,
        default: ""
      },
      id: {
        type: String,
        default: ""
      },
      showSubmitButton: {
        type: Boolean,
        default: true
      },
      showDescription: {
        type: Boolean,
        default: true
      },
      showTooltip: {
        type: Boolean,
        default: false
      },
      tooltipTitle: {
        type: String,
        default: ""
      },
      tooltipText: {
        type: String,
        default: ""
      },
      description: {
        type: String,
        default: ""
      }
    },
    data: () => ({
      file: {
        FileName: "",
        FileContent: "",
        FileType: ""
      },
      fileNames: [],
      fileBase64Strings: [],
      imageDragging: false,
      draftLoading: false

    }),
    computed: {
      ...mapGetters(["user", "activeAccountId"])
    },
    methods: {
      OnFileChange: function () {
        //currently there are only two file uploaders on DN7,
        //the returns part list uploader(which does not currently support multiple files),
        //and the claims images upload,
        //this is where the logic is currently different between logic between when there are multiple files allowed and not
        if(!this.allowMultiple){
          this.file.FileName = this.$refs.fileUploadInput.files[0].name
          this.file.FileType = this.$refs.fileUploadInput.files[0].type

          var self = this
          let reader = new FileReader()

          // onload is called when the selected file has fully loaded into memory
          // This also ensures the submit button isn't shown until we have all file data.
          reader.onload = function () {
            let arrayBuffer = this.result
            let array = new Uint8Array(arrayBuffer)
            let binaryString = String.fromCharCode.apply(null, array)
            self.file.FileContent = binaryString
          }
          reader.readAsArrayBuffer(this.$refs.fileUploadInput.files[0])
          
          this.$emit("input-change", this.file);
        }else{

          let haveAnImageOverAllowedFilesize = false;
          let MAX_IMAGE_SIZE_IN_MEGABYTES = 4;
          let self = this;
          Array.from(this.$refs.fileUploadInput.files).forEach(function(file) {
            if(file.size > MAX_IMAGE_SIZE_IN_MEGABYTES * constants.ONE_MEGABYTE){
              self.$store.commit("pushTimedMessage", {
                header: "Images cannot be larger than " + MAX_IMAGE_SIZE_IN_MEGABYTES +" megabytes.",
                IsError: true,
                sticky: true
              });
              haveAnImageOverAllowedFilesize = true;
            }
          });

          if(haveAnImageOverAllowedFilesize === true){
            return false;
          }
          const bulkFiles = document.getElementById("fileUploadInput").files;

          this.$emit("input-change-multi", bulkFiles);
        }

        return false;
      },
      OpenFileExplorer() {
        $("#fileUploadInput").click();
      },
      OnSubmit: function(){
        this.$emit("submit-file", this.file)
      },
      ClearFileContents: function(){
        this.file.FileType = ""
        this.file.FileName = ""
        this.file.FileContent = ""
      },
      ShowFileUploadErrors(errorsCsv){
        let downloadLink = this.GetFileErrorsLink(errorsCsv);
        this.$store.commit("pushMessage", {
          header: "File Upload Errors",
          message: "There were validation errors during the file upload process.",
          messageLinkText: "Download Errors",
          messageLink: downloadLink,
          IsError: true
        })
      },
      GetFileErrorsLink: function(errorsCsv){
        errorsCsv = "data:text/csv;charset=utf-8," + errorsCsv

        const data = encodeURI(errorsCsv);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", "File Upload Errors " + new Date() + ".csv");
        return link;
      },
      Uint8ToString(array){
        // the array is too large for the browser to be able to handle the transform,
        // so we must transform it in chunks. SEE: http://stackoverflow.com/a/12713326/471341
        let chunkSize = 0x8000; // keeping size of each chunk to 32-bits (int equallying 32768)
        let chunksArray = [];
        for (let i = 0; i < array.length; i += chunkSize) {
          chunksArray.push(String.fromCharCode.apply(null, array.subarray(i, i + chunkSize)));
        }
        let returnStr = chunksArray.join("");
        return returnStr;
      }
    }
  }

</script>
<style lang="scss">
#drop-zone {
    width: 100%;
    height: 100%;
    border: 2px dashed rgba(0,0,0,.3);
    border-radius: 20px;
    font-family: Arial;
    text-align: center;
    position: relative;
    line-height: 180px;
    font-size: 20px;
}

#drop-zone.imageHovering{
  background-color: lightcyan;
}

#drop-zone input {
    height: 100%;
    width: 100%;
    display: block;
    opacity: 0;
}

.image-upload-text{
  height: 0;
  display: block;
  position: absolute;
  width: 100%;
  top: -70%;
  left: 50%;
  transform: translate(-50%,-50%);
}

#drop-zone.mouse-over {
    border: 2px dashed rgba(0,0,0,.5);
    color: rgba(0,0,0,.5);
}

.images-uploaded-text{
    display: inline-block;
    height: 0;
    position: absolute;
    transform: translateX(-50%);
    *{
      display: block;
      height: 17px;
      font-size: 16px;
    }
    .file-names{
      font-style: italic;
    }
}

.ie-images-uploaded-text{
    display: inline-block;
    margin-top: 16px;
    *{
      display: block;
      height: 6px;
      font-size: 16px;
    }
    .file-names{
      font-style: italic;
    }
}

#clickHere {
    position: absolute;
    cursor: pointer;
    left: 50%;
    top: 50%;
    margin-left: -50px;
    margin-top: 20px;
    line-height: 26px;
    color: white;
    font-size: 12px;
    width: 100px;
    height: 26px;
    border-radius: 4px;
    background-color: #3b85c3;
}

#clickHere:hover {
    background-color: #4499DD;

}
</style>